<div *ngIf="isNoLayoutPage === false" class="container-fluid h-100 w-100 px-0 d-flex flex-column overflow-hidden">
  <dx-toolbar id="toolbar" height="68" class="applicationbar light">
    <dxi-item *ngIf="canChangePassword" widget="dxButton" [options]="menuButtonOptions" location="before"
              cssClass="header-menu-button"
    ></dxi-item>
    <dxi-item location="before" widget="dxButton" locateInMenu="never">
      <div *dxTemplate>
        <a [routerLink]="['/catalogs']">
          <img alt="nextPim Pim System" height="50" src="{{ logoUrl }}" style="margin-left: 6px" />
        </a>
      </div>
    </dxi-item>
    <dxi-item location="center" widget="dxButton" locateInMenu="never" *ngIf="currentNavigationTitle">
      <div *dxTemplate>
        <div class="d-flex flex-row justify-content-center">
          <div class="whiteHeaderText">{{ currentAccount }}</div>
        </div>
        <div class="d-flex flex-row justify-content-center">
          <div>
            <h6 class="whiteHeaderText">{{ currentNavigationTitle }}</h6>
          </div>
        </div>
      </div>
    </dxi-item>



    <dxi-item *ngIf="isJobRunning" widget="dxButton" [options]="warningButtonOptions" location="after">
      <div *dxTemplate>
        <div class="dx-icon dx-icon-warning text-danger" (mouseenter)="ttt()" (mouseleave)="ttt()" id="tt22"></div>
        <dx-tooltip target="#tt22" class="toolTip" [(visible)]="isJobWarningVisible">
          <div *dxTemplate="let data = data; of: 'content'">
            {{ 'Es läuft gerade ein Job zum aktuell ausgewählten Katalog' | translate }}
          </div>
        </dx-tooltip>
      </div>
    </dxi-item>

    <dxi-item *ngIf="canView('jobs')" id="jobs" location="after">
      <div *dxTemplate>
        <div class="jobs-item">
        <dx-button id="jobsToolTip" icon="runner" (onClick)="showJobs()" hint="Jobs"></dx-button>
          <span class="button-label">{{ 'Jobs' |translate }}</span>
          <div *ngIf="jobbadgevisible" class="badge-wrapper">
            <span [ngClass]="jobbadgeclass" class="badge badge-job">0</span>
        </div>
        </div>
      </div>
    </dxi-item>

    <dxi-item location="after" >
      <div class="menuButtonSeparator">

      </div>
    </dxi-item>

    <dxi-item widget="dxDropDownButton" location="after">
      <div *dxTemplate="let toolbaritem of 'helpButtonTemplate'">
        <div class="jobs-item">
          <np-help-button >
          <np-help-option
            icon="icon-glyphicons-basic-588-book-open-text"
            link="https://knowledge.nextpim.de/?utm_source=app.nextpim.de&utm_medium=affiliate&utm_campaign=wikilink"
            text="Wiki"
          ></np-help-option>
          <np-help-option
            icon="icon-glyphicons-basic-856-square-play"
            link="https://www.youtube.com/@nextpim4971"
            text="Video Tutorials"
          ></np-help-option>
            <np-help-option
              icon="icon-glyphicons-basic-713-announcement"
              route="/newsArticle"
              text="Produktnews"
            ></np-help-option>
            <np-help-option
              icon="icon-glyphicons-basic-78-headset"
              type="contactsupport"
              link=""
              text="Support kontaktieren"
          ></np-help-option>
        </np-help-button>
        </div>
        <span class="button-label">{{ 'Support' |translate }}</span>
      </div>
    </dxi-item>

    <dxi-item *ngIf="canChangePassword" location="after">

      <div *dxTemplate="let data of 'item'" class="jobs-item" id="accountToolTip">
        <dx-button
          (onClick)="accountButtonOptions.onClick($event)"
          [icon]="accountButtonOptions.icon"
          [stylingMode]="accountButtonOptions.stylingMode">
        </dx-button>

        <span class="button-label">{{ 'Account' |translate }}</span>
      </div>
    </dxi-item>
  </dx-toolbar>

  <dx-drawer class="flex-fill drawer np-drawer"
             template="template"
             [opened]="isOpened()"
             [minSize]="canChangePassword ? 42 : 0"
             [maxSize]="230"
             revealMode="expand"
             openedStateMode="shrink">
    <div *dxTemplate="let data of 'template'"
         style="width: 300px; height: 100%"
         (mouseenter)="drawerMouseEnter($event)"
         (mouseleave)="drawerMouseLeave($event)">

      <!-- Navigation-Bereich ohne Splitter -->
      <div class="navigation-wrapper">

        <!-- Datenprozess-Bereich -->
        <ng-container *ngIf="loginService.hasAddonDataProcess">
          <div class="np-dp-header" (click)="toggleDataProcess()">
            <div class="d-flex flex-row">
              <span class="np-dp-header-icon-cell">
                <span
                  class="glyphicon np-drawer-icon"
                  [ngClass]="isDataProcessOpen ? 'glyphicon-menu-down' : 'glyphicon-menu-right'">
                </span>
              </span>
              <span style="display: inline-flex; align-items: center" class="np-dp-header-text">
                {{ 'Datenprozess' | translate }}
              </span>
            </div>
          </div>

          <dx-list *ngIf="isDataProcessOpen"
                   class="navigation flex-fill"
                   [items]="dataProcessNavigation"
                   [hoverStateEnabled]="false"
                   [activeStateEnabled]="false"
                   [focusStateEnabled]="false"
                   selectionMode="single"
                   [selectedItems]="selectedNavigationItems">
            <div *dxTemplate="let item of 'item'" style="display: flex">
              <a [routerLink]="['/' + item.path]"
                 title="{{ item.text | translate }}"
                 [class]="item.linkDisabled ? 'disabled-a' : ''">
                <div class="d-flex flex-row">
                  <span style="width: 40px; display: inline-flex; align-items: center" class="{{ item.icon }} np-drawer-icon"></span>
                  <span style="display: inline-flex; align-items: center">{{ item.text | translate }}</span>
                </div>
              </a>
            </div>
          </dx-list>
        </ng-container>

        <!-- Normale Navigation -->
        <dx-list class="navigation flex-fill"
                 [items]="navigation"
                 [hoverStateEnabled]="false"
                 [activeStateEnabled]="false"
                 [focusStateEnabled]="false"
                 selectionMode="single"
                 [selectedItems]="selectedNavigationItems">
          <div *dxTemplate="let item of 'item'" style="display: flex">
            <a [routerLink]="['/' + item.path]"
               title="{{ item.text | translate }}"
               [class]="item.linkDisabled ? 'disabled-a' : ''">
              <div class="d-flex flex-row">
                <span style="width: 40px; display: inline-flex; align-items: center; position: relative" class="{{ item.icon }} np-drawer-icon">
                  <span *ngIf="hasOxomiSupllierUpdates(item.text)" class="menu-badge">0</span>
                </span>
                <span style="display: inline-flex; align-items: center">{{ item.text | translate }}</span>
              </div>
            </a>
            <np-license-upgrade-button *ngIf="item.linkDisabled" style="margin-left: 5px; float: right" />
          </div>
        </dx-list>

      </div>
    </div>
    <div id="content" class="h-100 p-0 dx-theme-background-color"><router-outlet></router-outlet></div>
  </dx-drawer>
</div>

<!-- Jobs Popover--->
<dx-popover
  target="#jobsToolTip"
  position="bottom"
  [showTitle]="true"
  [width]="'75%'"
  title="{{ 'Hintergrund Jobs' | translate }}"
  [showCloseButton]="true"
  [(visible)]="jobsVisible"
>
  <div *dxTemplate="let data of 'content'">
    <job-list
      #jobListCmp
      [visible]="jobsVisible"
      [storeName]="'JobListStateNewUI_V4_JOBLIST'"
      [jobListMode]="true"
      [catalogMode]="false"
      [adminMode]="false"
    >
      <!-- always choose ONE mode!! -->
    </job-list>
  </div>
</dx-popover>

<!-- Account Popover--->
<dx-popover
  target="#accountToolTip"
  class="accountMenuPopover"
  id="account"
  position="bottom"
  [width]="210"
  [showTitle]="false"
  [showCloseButton]="false"
  [hideOnOutsideClick]="true"
  (onHiding)="hideAccountMenu()"
  [(visible)]="accountMenuVisible"
>
  <div *dxTemplate="let data of 'content'">
    <a
      (click)="hideAccountMenu()"
      [routerLink]="['/Account/myAccount']"
      class="menuButton"
      title="Account: {{ account }}"
    >
 <span
   class="icon-glyphicons-basic-4-user"
 >
 </span>

      {{ 'Account' | translate }}
    </a>
    <a (click)="hideAccountMenu()" [routerLink]="['/Account/changePassword']" class="menuButton">
       <span
         class="icon-glyphicons-basic-683-key-rounded"
       >
 </span>
      {{ 'Passwort ändern' | translate }}
    </a>

    <div *ngIf="isAdmin()">
      <hr class="menuSeparator"/>
      <a (click)="hideAccountMenu()" [routerLink]="['/admin']" class="menuButton">
     <span
       class="icon-glyphicons-basic-316-wrench"
     >
 </span>
      {{ 'ADMIN' | translate }}
    </a>
      <a (click)="hideAccountMenu()" [routerLink]="['/admin/licenses']" class="menuButton">
      <span
        class="icon-glyphicons-basic-320-certificate"
      >
 </span>
      {{ 'Lizenzen' | translate }}
    </a>

    </div>
    <hr class="menuSeparator"/>
    <a (click)="logout()" class="menuButton">
    <span
      class="icon-glyphicons-basic-64-power"
    >
 </span>
      {{ 'Logout' | translate }}
    </a>
  </div>
</dx-popover>

<dx-popup
  [visible]="sendToCustomerPopupOpen"
  [width]="'500px'"
  [height]="'350px'"
  [showCloseButton]="true"
  [hideOnOutsideClick]="true"
  [showTitle]="true"
  [enableBodyScroll]="false"
  title="Katalog erfolgreich versendet"
>
  <div *dxTemplate="let data of 'content'" class="d-flex flex-column align-items-center justify-content-center">
    <div class="d-flex flex-column text-center" [ngStyle]="{ 'font-size': '1.5rem', gap: '2rem', width: '25ch' }">
      <div class="text-center">
        <i
          [ngStyle]="{ 'font-size': '4rem', display: 'inline-block' }"
          class="p-2 rounded-circle img-thumbnail dx-icon-check text-success border-success"
        ></i>
      </div>
      <div>{{ 'Der Produktkatalog wurde erfolgreich versendet.' | translate }}</div>
    </div>
  </div>
</dx-popup>

<template-editor-dialog
  *ngIf="templateService.importTemplateEditorVisible"
  [(visible)]="templateService.importTemplateEditorVisible"
  [showSelector]="false"
  [exportMode]="false"
></template-editor-dialog>
